"use client";

import React from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import BudgetViewTable from "./BudgetViewTable";
import { PublicBudgetData } from "./types";
import { useTranslations } from "use-intl";
type BudgetCompareDialogProps = {
  budgetPair: [PublicBudgetData, PublicBudgetData] | [null, null];
  onOpenChange: (open: boolean) => void;
};
const BudgetCompareDialog = ({
  budgetPair,
  onOpenChange
}: BudgetCompareDialogProps) => {
  const t = useTranslations("budget");
  const currentBudget = budgetPair[0];
  const comparedBudget = budgetPair[1];
  return <Dialog open={currentBudget !== null && comparedBudget !== null} onOpenChange={onOpenChange} data-sentry-element="Dialog" data-sentry-component="BudgetCompareDialog" data-sentry-source-file="BudgetCompareDialog.tsx">
      {currentBudget !== null && comparedBudget !== null && <DialogContent className="max-w-7xl">
          <DialogTitle>{t("comparingBudgets")}</DialogTitle>

          <BudgetViewTable budgetData={currentBudget} comparedBudgetData={comparedBudget} />
        </DialogContent>}
    </Dialog>;
};
export default BudgetCompareDialog;